import TopTicker from "@/pages/home/components/TopTicker";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import EntryBar from "@/pages/home/components/EntryBar";
import TopicCollections from "@/pages/home/components/TopicCollections";
import LatestFeeds from "@/pages/home/components/LatestFeeds";
import TagIndex from "@/pages/home/components/TagIndex";
import SourceArchive from "@/pages/home/components/SourceArchive";
import RankingBoard from "@/pages/home/components/RankingBoard";
import DownloadCta from "@/pages/home/components/DownloadCta";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <TopTicker />
      <Navbar />
      <main className="w-full">
        <Hero />
        <EntryBar />
        <TopicCollections />
        <LatestFeeds />
        <TagIndex />
        <SourceArchive />
        <RankingBoard />
        <DownloadCta />
      </main>
      <Footer />
    </div>
  );
}